import Theme from './Theme'

export const herbarium_records = {
  id: 'herbarium_records',
  source: 'herbarium_records',
  type: 'circle',
  paint: {
    'circle-color': Theme.herbarium_records,
    'circle-stroke-width': 1,
    'circle-stroke-color': '#fff'
  }
};

// Added PDW 2020-08-31
export const specialZones = {
  id: 'special_zone',
  source: 'special_zone',
  type: 'fill',
  paint: {
	'fill-color': Theme.specialZones,
	'fill-opacity': 0.5
  }
};

export const gdm_prediction = {
  id: 'gdm_prediction',
  source: 'gdm_prediction',
  type: 'fill',
  paint: {
    'fill-color': Theme.recommended_collection_area,
    'fill-opacity': 0.5
  }
};

export const gdm_prediction_dark = {
  id: 'gdm_prediction',
  source: 'gdm_prediction',
  type: 'fill',
  paint: {
    'fill-color': '#fff',
    'fill-opacity': 0.7
  }
};

export const current_climate_match = {
  id: 'current_climate_match',
  source: 'current_climate_match',
  type: 'fill',
  paint: {
    'fill-color': Theme.similar_environments_current,
    'fill-opacity': 0.3
  }
};

export const future_climate_match = {
  id: 'future_climate_match',
  source: 'future_climate_match',
  type: 'fill',
  paint: {
    'fill-color': Theme.similar_environments_future,
    'fill-opacity': 0.3
  }
};

export const domain_mask = {
  id: 'domain-mask',
  source: 'domain-mask',
  type: 'fill',
  paint: {
    'fill-color': Theme.recommended_collection_area,
    'fill-opacity': 0.5
  }
};



// WEBPACK FOOTER //
// ./src/Style.js